export const TOKENS = {
  DependencyContainer: '@trustedshops/tswp-core-composition:DependencyContainer'
};
